'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  minWidth: '160px',
  height: '40px',
  textAlign: 'center',
  textTransform: 'capitalize'
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref) {
  var disabled = _ref.disabled;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _extends3.default)({
    backgroundColor: disabled ? theme.colors.disabled : theme.colors.primary,
    color: theme.colors.primaryInverse,
    border: disabled ? 'solid ' + theme.borderBase + 'px ' + theme.colors.disabled : 'solid ' + theme.borderBase + 'px ' + theme.colors.primary,
    padding: '0 4px',
    borderRadius: theme.borderRadiusBase,
    '&:active': {
      backgroundColor: !disabled && theme.colors.primaryInverse,
      color: !disabled && theme.colors.primary
    }
  }, (0, _objectResolvePath2.default)(theme, 'PrimaryButton.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/PrimaryButton/PrimaryButton.style.js
// module id = 343
// module chunks = 0